import {NavItem} from '@interfaces/nav-item';


export const navItemsSuperadmin: NavItem[] = [
  {
    displayName: 'menu.dashboard',
    iconName: 'solar:widget-add-line-duotone',
    route: '/dashboard',
  },
  {
    displayName: 'menu.rooms',
    iconName: 'material-symbols:support-agent',
    route: '/support/room/list',
  },
  {
    displayName: 'menu.conversations',
    iconName: 'solar:chat-round-line-linear',
    route: '/conversations',
  },
  {
    displayName: 'menu.documents',
    iconName: 'solar:inbox-archive-broken',
    route: '/filemanager',
  },
  {
    displayName: 'menu.technicians',
    iconName: 'mdi:account-hard-hat-outline',
    route: '/users/technicians',
  },
  {
    displayName: 'menu.devices',
    iconName: 'mdi:cellphone-key',
    route: '/devices',
  }
];
